import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AddValueDriverDto, UpdateValueDriverDto, ValueDriver, ValueDriverDetails } from '../../models/value-driver';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env';

@Injectable({
  providedIn: 'root',
})
export class ValueDriverService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiPrefix}${environment.valueDrivers}`;
  private readonly sortingApiUrl = `${environment.apiPrefix}${environment.valueDrivers}/sorting`;

  getValueDrivers(): Observable<ValueDriver[]> {
    return this.http.get<ValueDriver[]>(`${environment.apiPrefix}${environment.valueDrivers}`);
  }

  getValueDriver(valueDriverId: number): Observable<ValueDriverDetails> {
    return this.http.get<ValueDriverDetails>(`${environment.apiPrefix}${environment.valueDrivers}/${valueDriverId}`);
  }

  createValueDriver(valueDriverData: AddValueDriverDto): Observable<ValueDriver> {
    return this.http.post<ValueDriver>(this.apiUrl, valueDriverData);
  }

  editValueDriver(valueDriverId: number, updateDto: UpdateValueDriverDto): Observable<ValueDriver> {
    const url = `${this.apiUrl}/${valueDriverId}`;
    return this.http.put<ValueDriver>(url, updateDto);
  }

  updateValueDriversOrder(valueDriverIds: number[]): Observable<any> {
    return this.http.put(this.sortingApiUrl, valueDriverIds);
  }

  deleteValueDriver(valueDriverId: number): Observable<void> {
    const url = `${this.apiUrl}/${valueDriverId}`;
    return this.http.delete<void>(url);
  }
}
